/**
 * Score de pertinence d'un texte pour une recherche (0 = aucun match).
 * Les deux chaînes doivent déjà être normalisées (txtToSearch).
 */
export function txtSearchScore(text: string, search: string): number {
    if (!search || search.length == 0) {
        return 1;
    }

    if (!text) {
        return 0;
    }

    if (text == search) {
        return 1000;
    }

    if (text.startsWith(search)) {
        return 900 - Math.min(text.length - search.length, 100);
    }

    const wordStartIndex = text.indexOf(" " + search);
    if (wordStartIndex >= 0) {
        return 700 - Math.min(wordStartIndex, 100);
    }

    const includeIndex = text.indexOf(search);
    if (includeIndex >= 0) {
        return 500 - Math.min(includeIndex, 100);
    }

    const searchWords = search.split(" ").filter(word => word.length > 0);
    if (searchWords.length > 1 && searchWords.every(word => text.includes(word))) {
        return 200;
    }

    return 0;
}
